import * as Dtos from '../../dtos/Tmd.dtos';
import { IFieldState, IRegistrationFormState } from "./index";

export const initialTrialGroupLaboratoryState: Dtos.TrialGroupLaboratory & IRegistrationFormState = {
    id: null,
    laboratoryId: null,
    laboratory: null,
    trialGroupId: null,
    trialGroup: null,
    dateCeased: null,
    active: null,
    dateEntered: null,
    dateModified: null,
    enteredBy: null,
    modifiedBy: null,
    saveAndReturn: false,
    personnels: []
}

export interface ITrialGroupLaboratoryReduxFormState {
    id: IFieldState<number>,
    laboratoryId: IFieldState<number>,
    trialGroupId:IFieldState<number>,
    dateCeased: IFieldState<string>,
    active: IFieldState<boolean>,
    dateEntered: IFieldState<string>,
    dateModified: IFieldState<string>,
    enteredBy: IFieldState<string>,
    modifiedBy: IFieldState<string>,
    saveAndReturn: IFieldState<boolean>
}